import script from "./foldable_content.vue?vue&type=script&setup=true&lang=ts"
export * from "./foldable_content.vue?vue&type=script&setup=true&lang=ts"

import "./foldable_content.vue?vue&type=style&index=0&id=5bbf28e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bbf28e2"]])

export default __exports__